<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="800px" class="addInvoiceDialogBox">
        <div class="addInvoiceDialog">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="发票类型" prop="invoiceType">
                    <el-select v-model="form.invoiceType" placeholder="请选择发票类型" @change="updateInvoiceType">
                        <el-option label="增值税普通发票" value="NORMAL"></el-option>
                        <el-option label="增值税专用发票" value="SPECIAL"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开票类型" prop="billType" v-if="form.invoiceType!='SPECIAL'">
                    <el-radio-group v-model="form.billType">
                        <el-radio
                                v-for="(item, index) in processTypeList"
                                :key="index"
                                :label="item.value"
                        >{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发票抬头" prop="title">
                    <el-input
                            v-model="form.title"
                            placeholder="请填写发票抬头"
                    ></el-input>
                </el-form-item>
                <el-form-item label="税号" prop="code" v-if="form.billType!='PERSONAL' || form.invoiceType=='SPECIAL'">
                    <el-input
                            v-model="form.code"
                            placeholder="请填写税号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="开户银行" prop="bank" v-if="form.invoiceType=='SPECIAL'">
                    <el-input
                            v-model="form.bank"
                            placeholder="请填写开户银行"
                    ></el-input>
                </el-form-item>
                <el-form-item label="银行账号" prop="bankAccount" v-if="form.invoiceType=='SPECIAL'">
                    <el-input
                            v-model="form.bankAccount"
                            placeholder="请填写银行账号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="注册地址" prop="address" v-if="form.invoiceType=='SPECIAL'">
                    <el-input
                            v-model="form.address"
                            placeholder="请填写注册地址"
                    ></el-input>
                </el-form-item>
                <el-form-item label="注册电话" prop="mobile" v-if="form.invoiceType=='SPECIAL'">
                    <el-input
                            v-model="form.mobile"
                            placeholder="请填写注册电话"
                    ></el-input>
                </el-form-item>
                <el-form-item label="收票人手机" prop="payeeTel">
                    <el-input
                            v-model="form.payeeTel"
                            placeholder="请填写收票人手机"
                    ></el-input>
                </el-form-item>
                <el-form-item label="收票人邮箱" prop="payeeEmail">
                    <el-input
                            v-model="form.payeeEmail"
                            placeholder="请填写收票人邮箱"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="buttonGroup">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import { saveInvoiceInfo,editInvoiceInfo,findInvoiceInfo } from '../../utils/interface';
    export default {
        name: "addInvoiceDialog",
        data(){
            return{
                processTypeList: [
                    {
                        value:"ENTERPRISE",
                        name: "企业",
                    },
                    {
                        value:"PERSONAL",
                        name: "个人",
                    },
                ],
                dialogVisible: false,
                title: '',
                form: {
                    title: "",
                    code: "",
                    bank: "",
                    bankAccount:"",
                    mobile:"",
                    address:"",
                    billType: "",
                    invoiceType: "",
                    payeeTel:"",
                    payeeEmail:"",
                },
                rules: {
                    title: [
                        {required: true, message: '请输入发票抬头', trigger: 'blur'}
                    ],
                    billType: [
                        {required: true, message: '请选择开票类型', trigger: 'change'}
                    ],
                    invoiceType: [
                        {required: true, message: '请选择发票类型', trigger: 'change'}
                    ],
                    code: [
                        {required: true, message: '请填写税号', trigger: 'blur'}
                    ],
                    bank: [
                        {required: true, message: '请填写开户行', trigger: 'blur'}
                    ],
                    bankAccount: [
                        {required: true, message: '请填写银行账号', trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: '请填写电话号码', trigger: 'blur'}
                    ],
                    address: [
                        {required: true, message: '请输入单位地址', trigger: 'blur'}
                    ],
                    payeeTel: [
                        {required: true, validator: this.validatorPhone, trigger: 'blur'}
                    ],
                    payeeEmail: [
                        {required: true, validator: this.validatorEmail, trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            updateInvoiceType(){
                // 如果是专用则开票默认为企业
                if(this.form.invoiceType=="SPECIAL"){
                    this.form.billType = "ENTERPRISE";
                }else{
                    this.form.billType = "";
                }
            },
            init(type,uuid){
                this.reset();
                if(type === 'add'){
                    this.title = '新增发票';
                } else {
                    this.title = '编辑发票';
                    if(uuid!=""){
                        findInvoiceInfo({uuid:uuid}).then((res)=>{
                            this.form = res;
                        });
                    }
                }
                this.dialogVisible = true;
            },
            // 联系方式校验
            validatorPhone(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入收票人手机号码'))
                } else if (!this.validate.isMobile(value)) {
                    callback(new Error('请输入正确的手机号码'))
                } else {
                    callback()
                }
            },
            // 邮箱地址校验
            validatorEmail(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入收票人邮箱地址'))
                } else if (!this.validate.isEmail(value)) {
                    callback(new Error('请输入正确的邮箱地址'))
                } else {
                    callback()
                }
            },
            // 保存
            submitForm(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.form.uuid != null){
                            editInvoiceInfo(this.form).then((res)=>{
                                this.$message.success('修改成功！');
                                this.dialogVisible = false;
                                this.$parent.invoiceTitleList();
                            });
                        }else{
                            saveInvoiceInfo(this.form).then((res)=>{
                                this.$message.success('保存成功！');
                                this.dialogVisible = false;
                                this.$parent.invoiceTitleList();
                            });
                        }
                    } else {
                        return false;
                    }
                })
            },
            // 重置
            reset(){
                this.form = {
                    title: "",
                    code: "",
                    bank: "",
                    bankAccount:"",
                    mobile:"",
                    address:"",
                    billType: "",
                    invoiceType: "",
                    payeeTel:"",
                    payeeEmail:"",
                }
            },
        }
    }
</script>

<style scoped lang="less">
    div{
        box-sizing: border-box;
    }
    .addInvoiceDialogBox {
        /deep/.el-dialog__body {
            padding: 0;
        }
        .addInvoiceDialog {
            .demo-ruleForm {
                padding: 30px;
            }
            .buttonGroup{
                text-align: right;
                width: 100%;
                padding: 6px 24px;
                border-top: 1px solid #ddd;
                /deep/.el-button{
                    padding: 10px 25px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/addInvoiceDialog.vue